import React, { useState, useEffect } from "react";
import { Font } from "../../theme/Font";
import { Color } from "../../theme/Color";
import { useSelector } from "react-redux";
import { isValidEmail } from "../../utils/validation";
import { useHistory } from "react-router-dom";
import {
  Description,
  Section,
  SectionTitle,
  SubTitle,
  SubmitButton,
} from "../DesignComponent/DesignComponents";
import axios from "axios";
import VideoPoster from "../../assets/NewSite/video-poster-img_11zon_11zon_11zon.webp";
import { trackPageVisit } from "../../utils/pageTracker";
import { API_URL } from "../../redux/constants/constants";

const styles = {
  decorator: {
    height: '5px',
    width: '20px',
    background: 'rgb(141, 142, 165)',
    borderRadius: '10px',
    position: 'absolute',
  },
  decorator2: {
    height: '20px',
    width: '5px',
    background: 'rgb(141, 142, 165)',
    borderRadius: '10px',
    position: 'absolute',
    top: '1.5rem',
    left: '-2px',
  }
}

const H_1 = () => {
  const data = useSelector(
    (state) => state?.landingPage?.data?.acf?.hero_banner_v1
  );

  const [Email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const navigate = useHistory();
  const [pageUrl, setPageUrl] = useState(window.location.href);
  const [visitedPages, setVisitedPages] = useState([]);
  useEffect(() => {
    trackPageVisit();
    setPageUrl(window.location.href);
    const storedPages =
      JSON.parse(sessionStorage.getItem("visitedPages")) || [];
    setVisitedPages(storedPages);
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!isValidEmail(Email)) {
      setEmailError(true);
      return;
    } else {
      const data = [
        {
          Last_Name: "null",
          Email: Email,
          Page_Link: pageUrl,
          User_Visited_Links: visitedPages.join(", "),
          Lead_URL: visitedPages[0],
        },
      ];
      try {
        await axios.post(`${API_URL}custom/v1/lead`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        navigate.push({
          pathname: "/schedule-demo",
          state: Email,
        });
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const handleInput = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setEmail(value);
  };
  return (
    <>
      <Section
        className="hero-banner text-white d-flex align-items-center text-lg-start text-center"
        style={{ backgroundColor: Color.theme_first }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-7 col-sm-8 mb-md-0 mb-3">
              <SubTitle
                className="sub-title mb-2"
                style={{ color: Color.white }}
              >
                {data?.text_before_title}
              </SubTitle>
              <SectionTitle className="mb-3">
                {/* {randomOption}, {optionAfterComma} */}
                {"Everything you need to run your frontline operations"}
              </SectionTitle>
              <Description
                className="description mb-4 w-90"
                style={{ color: Color.lightwhite }}
              >
                {data?.description}
              </Description>
              <form
                className="max-w-350 mx-lg-0 mx-auto"
                onSubmit={handleSubmit}
              >
                <div
                  className={`bg-white bg-opacity-10 px-2 pt-2 pb-1 mb-3 ${emailError ? "border-danger" : ""
                    }`}
                  style={{
                    borderRadius: "2px",
                    border: "1px solid rgba(255,255,255,.5)",
                  }}
                >
                  <label
                    className="fs-12 text-start d-block"
                    style={{ color: Color.lightwhite, fontFamily: Font.basel }}
                  >
                    Work email address
                  </label>
                  <input
                    type="text"
                    name="email"
                    value={Email}
                    onChange={handleInput}
                    placeholder="What's your email?"
                    className="bg-transparent border-0 outline-0 text-white w-100 rounded-0 placeholder-white"
                    style={{ fontFamily: Font.basel }}
                  />
                </div>
                <SubmitButton className="p-3 border-0 w-100 mb-2" type="submit">
                  Schedule demo
                </SubmitButton>
                <p className="fs-10" style={{ color: Color.lightwhite }}>
                  By clicking "Schedule Demo" you agree to LeanSuite's{" "}
                  <a
                    href="/legal/privacy"
                    className="text-white text-decoration-none fw-medium"
                  >
                    Privacy Policy
                  </a>
                </p>
              </form>
            </div>

            <div className="col-lg-7 col-md-7 col-sm-7 text-md-end text-start ">
              <div className="h-100 position-relative">
                <div style={{
                  ...styles.decorator,
                  top: '-2px',
                  left: '2rem',
                }}></div>
                <div style={{
                  ...styles.decorator,
                  top: '-2px',
                  left: '3.6rem',
                }}></div>
                <div style={{
                  ...styles.decorator2,
                }}></div>
                <div className="video-wrapper h-100 shadow" style={{
                  border: '6px solid #8D8EA5',
                  borderRadius: '21px',
                  background: '#8D8EA5'
                }}>
                  <div className="rounded-4 h-100" style={{
                    border: '10px solid #8D8EA5'
                  }}>
                    <video
                      className="w-100 h-100 rounded-4 "
                      controls
                      autoPlay
                      loop
                      muted
                      preload="metadata"
                      poster={VideoPoster}
                      style={{ objectFit: "cover" }}
                      loading="lazy"
                      fetchpriority="low"
                    >
                      <source
                        src={`https://staging2.theleansuite.com/wp-content/uploads/2024/06/home-page-video-continuous-improvement-process-0.9.webm`}
                        type="video/webm"
                      ></source>
                      <source
                        src={`https://staging2.theleansuite.com/wp-content/uploads/2024/06/home-page-video-continuous-improvement-process-0.9.mp4`}
                        type="video/mp4"
                      ></source>
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section >
    </>
  );
};
export default H_1;
